export default __webpack_public_path__ + "static/media/img8.d58ee850.jpg";